export default {
  data () {
    return {
      loadedSvg: null,
      seletorChange: 0
    }
  },
  props: {
    src: {
      required: true,
      type: String
    },
    color: {
      required: false,
      type: String
    }
  },
  mounted () {
    this.loadSvg()
  },
  watch: {
    src () {
      this.loadSvg()
    }
  },
  methods: {
    changeSeletor () {
      if (this.seletorChange < 3) {
        this.seletorChange = this.seletorChange + 1
      } else {
        this.seletorChange = 0
      }
    },
    loadSvg () {
      const newColor = this.color

      const client = new XMLHttpRequest()

      client.open('GET', this.src)

      client.onreadystatechange = () => {
        const fileContent = client.responseText
        let finalHaskColor
        let finalColorFill

        if (newColor) {
          if (fileContent.indexOf('"#') !== -1) {
            const fill = fileContent.indexOf('"#') + 1
            let colorFill = fileContent.substr(fill, 7)

            if (colorFill.charAt(5) === ' ') {
              colorFill = colorFill.replace(colorFill.charAt(5), '').replace(colorFill.charAt(6), '')
            }

            finalHaskColor = colorFill.replace(/"/g, '').replace(/>/g, '').replace(/\//g, '')

            if (finalHaskColor && finalHaskColor !== 'none' && finalHaskColor.length >= 4) {
              this.loadedSvg = fileContent.replace(new RegExp(finalHaskColor, 'g'), newColor)
            }
          }

          if (fileContent.indexOf('fill="') !== -1) {
            const fill = fileContent.indexOf('fill="') + 6

            let colorFill = fileContent.substr(fill, 7)

            if (colorFill.charAt(5) === ' ') {
              colorFill = colorFill.replace(colorFill.charAt(5), '').replace(colorFill.charAt(6), '')
            }

            finalColorFill = colorFill.replace(/"/g, '').replace(/>/g, '').replace(/\//g, '')

            if (finalColorFill && finalColorFill !== 'none' && finalColorFill.length >= 4) {
              this.loadedSvg = fileContent.replace(new RegExp(finalColorFill, 'g'), newColor)
            }
          }
        } else {
          this.loadedSvg = fileContent
        }
      }
      client.send()
    }
  }
}
